import { animated } from '#app/components/Primitives/Animated.js';
import { SMOOTH_SPRING_NO_REBOUND_TRANSITION } from '#app/utilities/animation.js';
import { css, styled } from 'styled-components';

const StyledMotionSvg = styled(animated.svg)`
  ${({ theme }) => css`
    color: var(--nav-item-color);
    cursor: pointer;
    padding: 8px;

    ${theme.mediaQueries.lg} {
      border-radius: 50%;
    }
  `}
`;

export const MobileMenuButton = ({
  isMenuOpen,
  toggleMenu,
}: {
  readonly isMenuOpen: boolean;
  readonly toggleMenu: () => void;
}) => {
  return (
    <button
      data-testid="mobileMenuButton"
      onClick={toggleMenu}
      type="button"
    >
      <StyledMotionSvg
        fill="none"
        height={40}
        tabIndex={0}
        viewBox="0 0 24 24"
        width={40}
      >
        <animated.path
          animate={{
            rotate: isMenuOpen ? 45 : 0,
            y: isMenuOpen ? 5 : 0,
          }}
          d="M 0 7 L 24 7"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          transition={SMOOTH_SPRING_NO_REBOUND_TRANSITION}
        />
        <animated.path
          animate={{
            rotate: isMenuOpen ? -45 : 0,
            y: isMenuOpen ? -5 : 0,
          }}
          d="M 0 17 L 24 17"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          transition={SMOOTH_SPRING_NO_REBOUND_TRANSITION}
        />
      </StyledMotionSvg>
    </button>
  );
};
